import { render, staticRenderFns } from "./Codemirror.vue?vue&type=template&id=512b5b7e&scoped=true&"
import script from "./Codemirror.vue?vue&type=script&lang=js&"
export * from "./Codemirror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b5b7e",
  null
  
)

export default component.exports